export type Country = {
  code: string // ISO 3166-1 alpha-2
  name: string
  dial: string // without +
  flag: string // emoji flag
}

// Lista resumida porém abrangente de países com código e DDI
// Nomes em PT-BR; pode ser extendida conforme necessário
export const COUNTRIES: Country[] = [
  { code: 'BR', name: 'Brasil', dial: '55', flag: '🇧🇷' },
  { code: 'US', name: 'Estados Unidos', dial: '1', flag: '🇺🇸' },
  { code: 'CA', name: 'Canadá', dial: '1', flag: '🇨🇦' },
  { code: 'MX', name: 'México', dial: '52', flag: '🇲🇽' },
  { code: 'AR', name: 'Argentina', dial: '54', flag: '🇦🇷' },
  { code: 'CL', name: 'Chile', dial: '56', flag: '🇨🇱' },
  { code: 'CO', name: 'Colômbia', dial: '57', flag: '🇨🇴' },
  { code: 'PE', name: 'Peru', dial: '51', flag: '🇵🇪' },
  { code: 'UY', name: 'Uruguai', dial: '598', flag: '🇺🇾' },
  { code: 'PY', name: 'Paraguai', dial: '595', flag: '🇵🇾' },
  { code: 'BO', name: 'Bolívia', dial: '591', flag: '🇧🇴' },
  { code: 'EC', name: 'Equador', dial: '593', flag: '🇪🇨' },
  { code: 'VE', name: 'Venezuela', dial: '58', flag: '🇻🇪' },
  { code: 'PT', name: 'Portugal', dial: '351', flag: '🇵🇹' },
  { code: 'ES', name: 'Espanha', dial: '34', flag: '🇪🇸' },
  { code: 'FR', name: 'França', dial: '33', flag: '🇫🇷' },
  { code: 'DE', name: 'Alemanha', dial: '49', flag: '🇩🇪' },
  { code: 'IT', name: 'Itália', dial: '39', flag: '🇮🇹' },
  { code: 'GB', name: 'Reino Unido', dial: '44', flag: '🇬🇧' },
  { code: 'IE', name: 'Irlanda', dial: '353', flag: '🇮🇪' },
  { code: 'NL', name: 'Holanda', dial: '31', flag: '🇳🇱' },
  { code: 'BE', name: 'Bélgica', dial: '32', flag: '🇧🇪' },
  { code: 'CH', name: 'Suíça', dial: '41', flag: '🇨🇭' },
  { code: 'AT', name: 'Áustria', dial: '43', flag: '🇦🇹' },
  { code: 'SE', name: 'Suécia', dial: '46', flag: '🇸🇪' },
  { code: 'NO', name: 'Noruega', dial: '47', flag: '🇳🇴' },
  { code: 'FI', name: 'Finlândia', dial: '358', flag: '🇫🇮' },
  { code: 'DK', name: 'Dinamarca', dial: '45', flag: '🇩🇰' },
  { code: 'PL', name: 'Polônia', dial: '48', flag: '🇵🇱' },
  { code: 'CZ', name: 'Tchéquia', dial: '420', flag: '🇨🇿' },
  { code: 'HU', name: 'Hungria', dial: '36', flag: '🇭🇺' },
  { code: 'RO', name: 'Romênia', dial: '40', flag: '🇷🇴' },
  { code: 'GR', name: 'Grécia', dial: '30', flag: '🇬🇷' },
  { code: 'RU', name: 'Rússia', dial: '7', flag: '🇷🇺' },
  { code: 'TR', name: 'Turquia', dial: '90', flag: '🇹🇷' },
  { code: 'AU', name: 'Austrália', dial: '61', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nova Zelândia', dial: '64', flag: '🇳🇿' },
  { code: 'JP', name: 'Japão', dial: '81', flag: '🇯🇵' },
  { code: 'KR', name: 'Coreia do Sul', dial: '82', flag: '🇰🇷' },
  { code: 'CN', name: 'China', dial: '86', flag: '🇨🇳' },
  { code: 'IN', name: 'Índia', dial: '91', flag: '🇮🇳' },
  { code: 'ID', name: 'Indonésia', dial: '62', flag: '🇮🇩' },
  { code: 'PH', name: 'Filipinas', dial: '63', flag: '🇵🇭' },
  { code: 'TH', name: 'Tailândia', dial: '66', flag: '🇹🇭' },
  { code: 'AE', name: 'Emirados Árabes', dial: '971', flag: '🇦🇪' },
  { code: 'SA', name: 'Arábia Saudita', dial: '966', flag: '🇸🇦' },
  { code: 'EG', name: 'Egito', dial: '20', flag: '🇪🇬' },
  { code: 'ZA', name: 'África do Sul', dial: '27', flag: '🇿🇦' },
  { code: 'NG', name: 'Nigéria', dial: '234', flag: '🇳🇬' },
  { code: 'KE', name: 'Quênia', dial: '254', flag: '🇰🇪' },
  { code: 'MA', name: 'Marrocos', dial: '212', flag: '🇲🇦' },
]

export const COUNTRY_BY_CODE = new Map(COUNTRIES.map((c) => [c.code, c]))
export const COUNTRY_BY_DIAL = new Map(COUNTRIES.map((c) => [c.dial, c]))

export function findCountryByDialPrefix(e164: string): Country | null {
  const s = (e164 || '').replace(/\D/g, '')
  if (!s) return null
  // Testa prefixos maiores primeiro
  const dials = [...COUNTRY_BY_DIAL.keys()].sort((a, b) => b.length - a.length)
  for (const d of dials) {
    if (s.startsWith(d)) return COUNTRY_BY_DIAL.get(d) || null
  }
  return null
}

